import React from "react";
import ReactPaginate from "react-paginate";
import { Form } from "react-bootstrap";
import "../../assets/css/pagination.css";
import arrowLeft from "../../assets/images/tablesImg/arrow_left.png";
import arrowRight from "../../assets/images/tablesImg/arrow_right.png";

const options = [
    { name: "10", id: 10 },
    { name: "20", id: 20 },
    { name: "30", id: 30 },
    { name: "40", id: 40 },
    { name: "50", id: 50 },
];

const PagePagination = ({
    setShow,
    setSkip,
    count,
    skip,
    show,
    selectDestItem,
}) => {
    const handlePageClick = (event) => {
        const selectedPage = event.selected;
        // Update skip value based on the selected page and the number of items per page (show)
        setSkip(selectedPage * show);
    };

    const handleShowChange = (e) => {
        setShow(e.target.value);
        // Reset skip value when changing the number of items per page
        setSkip(0);
    };

    // Calculate the number of pages based on the number of items per page (show)
    const pageCount = Math.ceil(count / show);

    return (
        <div
            className={
                selectDestItem === 0 || selectDestItem === 1
                    ? "pagnationForTeam"
                    : "pagnation"
            }
        >
            <span>
                Page {Math.floor(skip / show) + 1} of {pageCount}
            </span>
            <Form.Select
                value={show}
                onChange={handleShowChange}
                className="showPagnation"
            >
                {options.map((o) => {
                    const { name, id } = o;
                    return (
                        <option className="optionShow" key={id} value={id}>
                            Show {name}
                        </option>
                    );
                })}
            </Form.Select>

            <ReactPaginate
                className="reactPaginate"
                breakLabel="..."
                nextLabel={<img src={arrowRight} />}
                previousLabel={<img src={arrowLeft} />}
                onPageChange={handlePageClick}
                pageCount={pageCount}
                initialPage={skip / show}
                pageRangeDisplayed={2}
                marginPagesDisplayed={1}
            />
        </div>
    );
};

export default PagePagination;
